
let language = {
    "QP-MSG-DIALOG-MORE-TEXT": "More",
    "QP-MSG-DIALOG-CODE-TEXT": "code",
    "QP-MSG-DIALOG-DSC-TEXT": "reason",
    
    "QP-MSG-DIALOG-OK-BTN-TEXT": "OK",
    "QP-MSG-DIALOG-RETRY-BTN-TEXT": "RETRY",
    "QP-MSG-DIALOG-CANCEL-BTN-TEXT": "CANCEL",
    "QP-MAG-DIALOG-CHANGE-PSD-TEXT":"CHANGE PASSWORD"
};

export { language }